export default __webpack_public_path__ + "static/media/stp.9efcdc2d.svg";